/**
 * @file index.tsx
 *
 * @fileoverview Renders blog detail page.
 */
import BlogDetailPage, { getServerSideProps } from '~/jobiqo/pages/blog';
export default BlogDetailPage;
export { getServerSideProps };
